import {
  TPersonalDataApplicationsStore,
  TPersonalDataWhyApplicationsFormResponse,
} from '~/store/processing-personal/types.ts';
import { PayloadAction } from '@reduxjs/toolkit';

export const whyApplicationFormRevokeFulfilled = (
  state: TPersonalDataApplicationsStore,
  action: PayloadAction<TPersonalDataWhyApplicationsFormResponse>
) => {
  state.applicationDocumentId = action.payload.applicationDocumentId;

  state.loading = false;
  state.error = null;
  state.status = '';
};

export const whyApplicationFormRevokePending = (state: TPersonalDataApplicationsStore) => {
  state.loading = true;
  state.applicationDocumentId = '';
};
